import { Banner } from "@hireart/component-library";
import PropTypes from "prop-types";

const FormError = ({ error }) => {
  if (error.length > 0) {
    return (
      <Banner className="mb-16" variant="error">
        {typeof error === "object" ? error[0] : error}
      </Banner>
    );
  }
  return null;
};

FormError.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};

export { FormError };
